import { FetchDemandReportPayload } from './types';
import { postApiGalaxyServer } from 'services';

export const fetchDemandReport = ({
  config = {},
  params,
  token,
}: BaseApiParams<FetchDemandReportPayload>) =>
  postApiGalaxyServer('/rails_api/demand_report', params, config, token);
